
import React,{useEffect} from "react";

const LoadingScreen = () => {
  useEffect(() => {
    // Hide Google Translate element when the component mounts
    const googleTranslateElement = document.getElementById("google_translate_element");
    if (googleTranslateElement) {
      googleTranslateElement.style.display = "none";
    }
    const trasnlateHindiButoon = document.querySelector(".translation-buttons");
    if (trasnlateHindiButoon) {
      trasnlateHindiButoon.style.display = "none";
    }


    // Show Google Translate element when the component unmounts
    return () => {
      if (googleTranslateElement) {
        googleTranslateElement.style.display = "block";
      }
      if 
(trasnlateHindiButoon) {
        trasnlateHindiButoon.style.display = "block";
      }
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white  z-50">
<div class="spinner">
    <div class="spinnerin"></div>
</div>
    </div>
  );
};

export default LoadingScreen;
